/* =====================================================================
   KARTOGRAF · JS comune del nuovo sito (12/10/2026)
   - menu telefono + sottomenu Servizi
   - voce di menu attiva (in base al nome del file)
   - fascia che scorre (kg-marquee): duplica il contenuto senza buchi
   - mosaico di foto (kg-sec--dinamica / [data-kg-mosaic])
   - scritta KARTOGRAF a contorno (kg-sec--fantasma)
   - effetto "sezione in primo piano" (mouse su computer, centro schermo su telefono)
   - ingresso delle card allo scroll
   Shopify (12/10/2026): le foto stanno nei File del negozio con prefisso kgs-;
   <html data-kg-files="//…/cdn/shop/files/"> (in layout/theme.liquid) da' la cartella.
   ===================================================================== */
(function(){
  'use strict';
  var doc=document, html=doc.documentElement, body=doc.body;
  var FILES=html.getAttribute('data-kg-files')||'';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  html.classList.add('kg-js');
  function $$(s,c){return [].slice.call((c||doc).querySelectorAll(s))}

  /* ---------- menu telefono ---------- */
  var header=doc.querySelector('.kg-header');
  if(header){
    var burger=header.querySelector('.kg-burger');
    if(burger) burger.addEventListener('click',function(){
      var open=header.classList.toggle('is-open');
      body.classList.toggle('kg-menu-open',open);
      burger.setAttribute('aria-expanded',open?'true':'false');
    });
    $$('.kg-has-drop>a',header).forEach(function(a){
      a.addEventListener('click',function(e){
        if(window.innerWidth<=860){e.preventDefault();a.parentNode.classList.toggle('is-open')}
      });
    });
    /* voce attiva */
    var here=(location.pathname.split('/').pop()||'index.html').toLowerCase();
    $$('a[href]',header).forEach(function(a){
      var href=a.getAttribute('href'); if(href.indexOf('#')>-1||/^https?:/.test(href)) return;
      var f=(href.split('?')[0].split('/').pop()||'').toLowerCase();
      if((f&&f===here)||(href==='/'&&location.pathname==='/')){
        a.classList.add('is-on');a.setAttribute('aria-current','page');
        var li=a.closest('.kg-has-drop'); if(li){var top=li.querySelector(':scope>a'); if(top) top.classList.add('is-on')}
      }
    });
  }

  /* ---------- fascia che scorre ---------- */
  $$('.kg-marquee').forEach(function(m){
    var inn=m.querySelector('.kg-marquee__in'); if(!inn) return;
    var base=inn.innerHTML, guard=0;
    while(inn.scrollWidth<Math.max(window.innerWidth,1440)*1.05&&guard++<8) inn.innerHTML+=base;
    if(m.querySelectorAll('.kg-marquee__in').length<2){var c=inn.cloneNode(true);c.setAttribute('aria-hidden','true');m.appendChild(c)}
  });

  /* ---------- mosaico di foto vere (B) ---------- */
  var PICS=['prod-kit-ristorante','prod-sito-social-start','prod-t-shirt-pezzo-unico-fronte-retro','prod-immagine-coordinata','prod-modellazione-3d','prod-shopper-serigrafate','prod-kit-workwear','prod-abbonamento-social-growth','prod-pannelli-forex-dibond-plexiglass','prod-etichette-adesive-personalizzate','prod-t-shirt-donna-oversize-personalizzata','prod-porta-qr-3d-da-tavolo','prod-bandiera-a-vela','prod-carta-velina-personalizzata','prod-kit-palestra','prod-vettorializzazione-logo','prod-adesivi-vetrofanie','prod-accendini-personalizzati','prod-menu-plastificati','prod-scatole-personalizzate','prod-t-shirt-urban-personalizzata','prod-grafica-menu','prod-espositore-3d-su-misura','prod-stampa-su-tela-canvas'];
  function mosaic(sec,i){
    if(sec.querySelector(':scope>.kg-mosaic')) return;
    var list=(sec.getAttribute('data-kg-mosaic')||'').split(',').map(function(s){return s.trim()}).filter(Boolean);
    /* 13/10 sfondi: miniature 440 px kgsf-<nome>.jpg (prima: foto intere kgs-) */
    var pics=(list.length?list:PICS).map(function(p){return /[\/.]/.test(p)?p:FILES+'kgsf-'+p+'.jpg'});
    var rows=parseInt(sec.getAttribute('data-kg-rows')||'0',10)||Math.max(2,Math.min(6,Math.ceil(sec.offsetHeight/218)+1));
    var d=doc.createElement('div');d.className='kg-mosaic';d.setAttribute('aria-hidden','true');
    var h='';
    for(var r=0;r<rows;r++){
      var off=(i*5+r*7)%pics.length, row='';
      for(var k=0;k<2;k++)for(var j=0;j<pics.length;j++)row+='<img alt="" decoding="async" loading="lazy" src="'+pics[(j+off)%pics.length]+'">';
      h+='<div class="kg-mosaic__row">'+row+'</div>';
    }
    d.innerHTML=h; sec.insertBefore(d,sec.firstChild);
  }
  $$('.kg-sec--dinamica,[data-kg-mosaic]').forEach(mosaic);

  /* ---------- scritta KARTOGRAF a contorno (C) ---------- */
  $$('.kg-sec--fantasma').forEach(function(s){
    if(s.querySelector(':scope>.kg-ghost')) return;
    var g=doc.createElement('div');g.className='kg-ghost'+(s.hasAttribute('data-kg-ghost-alto')?' kg-ghost--alto':'');g.setAttribute('aria-hidden','true');
    g.textContent='KARTOGRAF · KARTOGRAF · KARTOGRAF · KARTOGRAF · KARTOGRAF · KARTOGRAF · ';
    s.insertBefore(g,s.firstChild);
  });

  /* ---------- sezione in primo piano ---------- */
  var secs=$$('.kg-main>section,.kg-main>.kg-marquee,.kg-main>aside');
  secs.forEach(function(s){
    s.classList.add('kg-fx');
    if(getComputedStyle(s).position==='static') s.style.position='relative';
    var g=doc.createElement('span');g.className='kg-glow';g.setAttribute('aria-hidden','true');s.appendChild(g);
  });
  function setFocus(s){
    secs.forEach(function(x){x.classList.toggle('is-focus',x===s)});
    body.classList.toggle('kg-has-focus',!!s);
  }
  var canHover=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if(secs.length){
    if(canHover){
      secs.forEach(function(s){
        s.addEventListener('mouseenter',function(){setFocus(s)});
        s.addEventListener('mouseleave',function(e){if(!e.relatedTarget||!s.contains(e.relatedTarget))setFocus(null)});
      });
    }else if('IntersectionObserver' in window){
      var active=false, cur=null;
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting)cur=e.target});
        if(active)setFocus(cur);
      },{rootMargin:'-48% 0px -48% 0px'});
      secs.forEach(function(s){io.observe(s)});
      /* parte al primo tocco vero: la pagina appena aperta resta piena e accesa */
      window.addEventListener('touchstart',function(){if(!active){active=true;setFocus(cur)}},{passive:true,once:true});
    }
  }

  /* ---------- barra fissa WhatsApp + Preventivo (telefono): appare dopo la hero ---------- */
  (function(){
    var hero=doc.querySelector('.kg-main>.kg-hero'), ticking=false;
    function upd(){
      ticking=false;
      var lim=hero?Math.max(240,hero.offsetTop+hero.offsetHeight*0.55-window.innerHeight*0.5):240;
      body.classList.toggle('kg-float-on',window.pageYOffset>lim);
    }
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd)}},{passive:true});
    window.addEventListener('resize',upd); upd();
  })();

  /* ---------- ingresso delle card allo scroll (C) ---------- */
  var LIFT='.kg-card,.kg-prod,.kg-offer,.kg-step,.kg-rev,.kg-cat,.kg-tile,.kg-plan,.kg-trust li,.kg-info>a';
  /* solo dentro il contenuto nuovo (.kg-main): niente effetti su configuratori e pagine Dawn */
  var LIFTS=LIFT.split(',').map(function(s){return '.kg-main '+s}).join(',');
  $$(LIFTS).forEach(function(el){el.classList.add('kg-lift')});
  if(!reduce&&'IntersectionObserver' in window){
    var els=$$(LIFTS+',.kg-main .kg-stat,[data-kg-rv]');
    var rio=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target; el.classList.add('is-in'); rio.unobserve(el);
        setTimeout(function(){el.style.transitionDelay=''},900);
      });
    },{rootMargin:'0px 0px -5% 0px'});
    els.forEach(function(el){
      var sib=el.parentNode?[].indexOf.call(el.parentNode.children,el):0;
      el.classList.add('kg-rv'); el.style.transitionDelay=((sib%6)*70)+'ms'; rio.observe(el);
    });
  }
})();